exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-0dbb20a2] {\n    font-size: 38px;\n    line-height: 50px;\n    margin-bottom: 15px;\n    font-weight: 700;\n    color: black;\n    letter-spacing: 1px;\n    margin-top: 0;\n}\n.emoticon[data-v-0dbb20a2] {\n  margin-right: 15px;\n}\n@media only screen and (max-width: 575px) {\nh2[data-v-0dbb20a2] {\n        font-size: 29px;\n        line-height: 45px;\n}\n}\n.dashboard-hello-image[data-v-0dbb20a2] {\n    width: 60%;\n\n    position: fixed;\n    bottom: 0px;\n    left: 0;\n    margin-left: 23%;\n}\ndiv.card[data-v-0dbb20a2] {\n  max-width: 80%;\n}\n", ""]);

// exports
